(() => {
  const scrolledClass = 'rh-header-scrolled';
  let framePending = false;

  const updateHeaderState = () => {
    if (document.body) {
      document.body.classList.toggle(scrolledClass, window.scrollY > 24);
    }
    framePending = false;
  };

  const requestHeaderUpdate = () => {
    if (framePending) return;
    framePending = true;
    window.requestAnimationFrame(updateHeaderState);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateHeaderState, { once: true });
  } else {
    updateHeaderState();
  }

  window.addEventListener('scroll', requestHeaderUpdate, { passive: true });

  const isComparisonRoute = () => {
    const path = window.location.pathname || '';
    return path.indexOf('/pages/') === 0 && (path.indexOf('-vs-') !== -1 || path.indexOf('refurbished-vs-') !== -1);
  };

  const prepareMobileComparisonTables = () => {
    if (!isComparisonRoute()) return;

    const tableSelector = 'main table, .rte table, .shopify-policy__body table';
    document.querySelectorAll(tableSelector).forEach((table) => {
      if (table.dataset.rhMobileCompareTable || table.closest('header, footer, form, [data-rh-no-mobile-table-cards]')) return;
      if (table.querySelector('input, select, textarea, button')) return;

      const headerRow = table.tHead && table.tHead.rows[0];
      const bodyRows = Array.from(table.tBodies).flatMap((body) => Array.from(body.rows));
      const columnCount = headerRow ? headerRow.cells.length : 0;
      const hasSpans = Boolean(table.querySelector('[colspan], [rowspan]'));
      const hasConsistentRows = bodyRows.length > 0
        && bodyRows.length <= 16
        && !hasSpans
        && bodyRows.every((row) => row.cells.length === columnCount);
      const isSimpleDecisionTable = headerRow
        && columnCount >= 2
        && columnCount <= 3
        && hasConsistentRows;
      const isModelDecisionTable = headerRow
        && columnCount === 4
        && hasConsistentRows;

      if (isSimpleDecisionTable || isModelDecisionTable) {
        const labels = Array.from(headerRow.cells).map((cell) => cell.textContent.trim());
        bodyRows.forEach((row) => {
          Array.from(row.cells).forEach((cell, index) => {
            if (index > 0 && labels[index]) cell.dataset.rhMobileLabel = labels[index];
          });
        });
        table.dataset.rhMobileCompareTable = 'cards';
        if (isModelDecisionTable) table.dataset.rhMobileCompareLayout = 'model-decision';
        const parent = table.parentElement;
        if (parent && /(?:table-wrap|table-container|table-scroll)/.test(parent.className || '')) {
          parent.classList.add('rh-mobile-compare-cards-wrap');
        }
        return;
      }

      table.dataset.rhMobileCompareTable = 'scroll';
      const parent = table.parentElement;
      if (parent && /(?:table-wrap|table-container|table-scroll)/.test(parent.className || '')) {
        parent.classList.add('rh-mobile-compare-scroll-wrap');
        return;
      }

      const wrapper = document.createElement('div');
      wrapper.className = 'rh-mobile-compare-scroll-wrap';
      wrapper.setAttribute('role', 'region');
      wrapper.setAttribute('aria-label', table.getAttribute('aria-label') || 'Scrollable comparison table');
      wrapper.tabIndex = 0;
      table.parentNode.insertBefore(wrapper, table);
      wrapper.appendChild(table);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', prepareMobileComparisonTables, { once: true });
  } else {
    prepareMobileComparisonTables();
  }

  const serviceVideos = document.querySelectorAll('[data-rh-autoplay-video]');
  const reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const hydrateVideo = (video) => {
    if (video.dataset.rhVideoLoaded === 'true') return;

    let sourceAdded = false;
    video.querySelectorAll('source[data-src]').forEach((source) => {
      if (!source.getAttribute('src')) {
        source.setAttribute('src', source.dataset.src);
        sourceAdded = true;
      }
    });

    if (sourceAdded) video.load();
    video.dataset.rhVideoLoaded = 'true';
  };

  const startVideo = (video) => {
    hydrateVideo(video);
    if (!reduceMotion) video.play().catch(() => {});
  };

  if (serviceVideos.length && 'IntersectionObserver' in window) {
    const videoObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const video = entry.target;
          if (entry.isIntersecting) {
            startVideo(video);
          } else {
            video.pause();
          }
        });
      },
      { rootMargin: '240px 0px', threshold: 0.18 }
    );

    serviceVideos.forEach((video) => videoObserver.observe(video));
  } else {
    serviceVideos.forEach((video) => startVideo(video));
  }
})();
